// biome-ignore-all lint/a11y/useAriaPropsSupportedByRole: shared component anatomy.
// biome-ignore-all lint/a11y/useFocusableInteractive: shared component anatomy.
// biome-ignore-all lint/a11y/noAutofocus: shared component anatomy.
// biome-ignore-all lint/style/useTemplate: shared component anatomy.
// biome-ignore-all lint/complexity/useIndexOf: shared component anatomy.
// biome-ignore-all lint/security/noDangerouslySetInnerHtml: shared component anatomy.
// biome-ignore-all lint/suspicious/noArrayIndexKey: shared component anatomy.
// biome-ignore-all lint/a11y/useSemanticElements: shared component anatomy.
// biome-ignore-all lint/a11y/noInteractiveElementToNoninteractiveRole: shared component anatomy.
// biome-ignore-all lint/a11y/noStaticElementInteractions: shared component anatomy.
// biome-ignore-all lint/a11y/useKeyWithClickEvents: shared component anatomy.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: shared component anatomy.
// biome-ignore-all lint/correctness/useExhaustiveDependencies: shared component anatomy.
import { codeToHtml } from "shiki";

const lightTheme = "github-light";
const darkTheme = "github-dark";

/**
 * Highlight code with shiki.
 *
 * When `theme` is omitted, renders dual light/dark output using CSS variables
 * (adapts to the site's color mode automatically).
 *
 * When `theme` is provided, renders single-theme output with inline styles
 * matching the specified shiki theme (e.g. "dracula", "nord", "monokai").
 */
export async function highlightCode(
  code: string,
  language: string = "tsx",
  theme?: string,
) {
  if (theme) {
    return codeToHtml(code, {
      lang: language,
      theme,
    });
  }

  return codeToHtml(code, {
    lang: language,
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
    defaultColor: false,
  });
}
